/*
 * NEXZ V2 — motion layer (doc 13). One IntersectionObserver, no library.
 *
 * Scroll reveal: elements marked [data-nexz-reveal] fade-up 12px once when
 * 15% enters the viewport, then latch (data-revealed) and are unobserved —
 * no idle rAF, one entrance per element per page-life (doc 13 rules).
 *
 * Progressive enhancement, three ways safe:
 *   1. The hidden initial state (opacity/transform) is scoped in CSS to
 *      :root[data-nexz-motion] — a flag THIS script sets. JS off ⇒ flag
 *      absent ⇒ content fully visible, never stuck hidden.
 *   2. prefers-reduced-motion: reduce ⇒ we return before setting the flag,
 *      so again nothing is hidden and nothing animates.
 *   3. Homepage sections are auto-tagged here rather than in Liquid, so
 *      the attribute only ever exists once motion is confirmed on; the
 *      tagged sections are all below the fold (the hero is skipped), so
 *      tagging after load causes no visible flash.
 */
(function () {
  if (typeof window === 'undefined') return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  document.documentElement.setAttribute('data-nexz-motion', '');

  // Homepage: reveal every top-level section except the hero (index 0,
  // above the fold / LCP — never hidden).
  var main = document.querySelector('main[data-template="index"]');
  if (main) {
    var sections = main.querySelectorAll(':scope > .shopify-section');
    for (var i = 1; i < sections.length; i++) {
      sections[i].setAttribute('data-nexz-reveal', '');
    }
  }

  var targets = document.querySelectorAll('[data-nexz-reveal]:not([data-revealed])');
  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      for (var j = 0; j < entries.length; j++) {
        var entry = entries[j];
        if (!entry.isIntersecting) continue;
        entry.target.setAttribute('data-revealed', '');
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.15 }
  );

  for (var k = 0; k < targets.length; k++) observer.observe(targets[k]);
})();
